const initialState = {
    list: [],
    error: {}
};

const CategoryReducer = (state, action) => {
    if (state === null || state === undefined) {
        state = initialState;
    }
    switch (action.type) {
        case "GET_CATEGORY_SUCCESS":
            state = {
                ...state,
                list: [...action.payload]

            };
            return state;
        case "GET_CATEGORY_ERROR":
            state = {
                ...state,
                error: action.payload
            };
            return state;
        default:
            return state;
    }
};

export default CategoryReducer;
